// src/helpers/page/description/IOPageContentSelector.ts
import { CheerioAPI } from 'cheerio';

const RAW_CONTENT_SELECTORS = [
    'div.page-content',
    'div[data-elementor-type="wp-page"]',
    '.wp-post',
    'article[id^="post-"]',
] as const;

/**
 * Pick the first non-empty container out of: RAW_CONTENT_SELECTORS
 *
 * Always returns a Cheerio object (possibly empty if none matched).
 */
export function getRawContent($: CheerioAPI) {
    for (const sel of RAW_CONTENT_SELECTORS) {
        const found = $(sel);
        if (found.length) {
            return found;
        }
    }
    // fallback to the last selector (even if it's empty)
    return $(RAW_CONTENT_SELECTORS[RAW_CONTENT_SELECTORS.length - 1]);
}
